// extracted by mini-css-extract-plugin
module.exports = {"highlight":"Highlight_highlight__1z84J"};